module.exports = __webpack_public_path__ + "img/user.767558c1.svg";